<template>
  <p>Registration for VIZBI 2019 is now closed.</p>
  <table>
    <thead>
      <tr>
        <th>Registrant type</th>
        <th>Registration fee</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Academia:</td>
        <td>€450</td>
      </tr>
      <tr>
        <td>Student:</td>
        <td>€350</td>
      </tr>
      <tr>
        <td>Industry:</td>
        <td>€700</td>
      </tr>
    </tbody>
  </table>
  <p>The registration deadline was <strong>15 February 2019</strong> (extended from 1 February
    2019). Registration was on a first-come, first-served basis; places were limited and confirmed
    after payment was received. To present a poster and lightning talk, participants first registered
    and then submitted their work before the extended upload deadline (4 March 2019).
  </p>
  <p>Registration included admission to the conference, conference materials, meals and coffee
    breaks: accommodation was not included. For information about hotels and transport, please see
    the <router-link to="/2019/Venue">Venue page</router-link>. For full details about
    registration, payment and refunds, please see the
    <a href="http://www.embl.de/training/events/info_participants/terms/index.html">EMBL meeting
      participant terms and conditions</a>.
  </p>
  <h4>EMBL Corporate Partnership Programme Fellowships</h4>
  <p>A limited number of fellowships were available to eligible students and researchers.
    Applications closed in December 2018; successful candidates were notified in early January 2019.
  </p>
  <h4>ISCB Discount</h4>
  <p>Members of the
    <a href="http://iscb.org/">International Society for Computational Biology (ISCB)</a> received
    a 20% registration discount (conference only, not Masterclass). Participants were encouraged to
    consider joining the ISCB to take advantage of this discount, as well as
    <a href="http://www.iscb.org/iscb-membership">other membership benefits</a>.
  </p>
  <h4>Press Registration</h4>
  <p>Accredited journalists were eligible to register for a reduced press rate. Registrants were
    required to provide accreditation or equivalent proof of press membership after registration.
    Acceptance of press registration was granted at EMBL's discretion. For more information please
    read the
    <a href="http://www.embl.de/training/events/info_participants/faqs/faqs_pressreg/index.html">
      FAQs for press</a>.
  </p>
</template>

<style scoped>
table {
  border-collapse: collapse;
  margin-bottom: 1em;
  width: 100%;
}
tr:nth-child(even) {
  background: #eee;
}
</style>
